
<template>
    <div class="svg_box">
        <!-- <div class="svg_bg"> -->
            <!-- <svg height="150" width="150">
                <polygon points="75,0 150,150 0,150" style="fill:none;stroke:#2e6d90;stroke-width:1" />
            </svg> -->
        <!-- </div> -->
        <!-- <svg  height="150" width="150" >
            <polygon points="75,20 130,90 20,90"
            style="fill:rgba(88,239,250,0.4);stroke-width:0"/>
            <circle cx="75" cy="20" r="2" fill="#58edf8" />
            <circle cx="130" cy="90" r="2" fill="#58edf8" />
            <circle cx="20" cy="90" r="2" fill="#58edf8" />
        </svg> -->
        <div id="myChart" :style="{width: '400px', height: '280px'}"></div>
    </div>
</template>
<script>
import $ from "jquery"
//引入基本模板
 let echarts = require('echarts/lib/echarts')
 
// 引入饼状图组件
require('echarts/lib/chart/radar')
// 引入提示框和title组件，图例
require('echarts/lib/component/tooltip')
require('echarts/lib/component/title')
require('echarts/lib/component/legend')
// Vue.prototype.$echarts = echarts //引入组件
export default {
    props: ["moduleList"],
    data() {
        return {
            
        }
    },
    mounted() {
         this.drawLine();
    },
    methods: {
       drawLine(){
            // 基于准备好的dom，初始化echarts实例
            let myChart = echarts.init(document.getElementById('myChart'))
            // 绘制图表
            let option = {
                title: {
                    text: ''
                },
                tooltip: {
                    trigger: 'axis'
                },
                
                radar: 
                {
                    indicator: [
                        // {text: '品牌', max: 100},
                        // {text: '内容', max: 100},
                        // {text: '可用性', max: 100}
                    ],
                    center: ['50%', '50%'],
                    radius : '75%',
                    axisLine: {            // 坐标轴线
                        show: false        // 默认显示，属性show控制显示与否
                    },
                    splitLine : {
                        show : true,
                        lineStyle : {
                            width : 1,
                            color : '#1f5093' // 图表背景网格线的颜色
                        }
                    },
                    splitArea : {
                        show : true,   
                        areaStyle : {
                            color: ["#06143a"]  // 图表背景网格的颜色
                        }
                    },
                    name: {
                        textStyle: {
                            color: '#DFE0E5',
                            fontSize:"16"
                        }
                    }
                },
                series: 
                    {
                        type: 'radar',
                        tooltip: {
                            trigger: 'item'
                        },
                        areaStyle: {},
                        itemStyle: {
                            normal: {
                                color : "rgba(0,0,0,0)", // 图表中各个图区域的边框线拐点颜色
                                areaStyle: {
                                    type: 'default',
                                    opacity: 0.4, // 图表中各个图区域的透明度
                                    color: "#58effa" // 图表中各个图区域的颜色
                                }
                            }
                        },
                        data:[
                            {
                                // value: [60, 73, 85],
                                value: [],
                                name: '',
                            }
                        ]
                    }
                
            };
            this.moduleList.forEach((item,index) => {
                var curObj = {};
                curObj.text = item.name+"("+ (item.score || '0') +")";
                curObj.max = item.fullScore;
                option.radar.indicator.push(curObj);
                option.series.data[0].value.push(item.score);
            });
            myChart.setOption(option);
        }
    }
}
</script>
<style lang="less" >
</style>


// WEBPACK FOOTER //
// src/components/proChart.vue